module.exports = __webpack_public_path__ + "static/uni_shaw-bba8a2293d7f7eec630d1a555906aeae.png";